import type { ReactNode } from 'react'

export type SummaryTone = 'neutral' | 'danger' | 'success' | 'info'

export interface SummaryMetric {
  key: string
  label: string
  /** Valeur formatée; `null` : inconnue (erreur, chargement) — affichée « — », jamais un faux 0 $. */
  value: string | null
  detail: string
  tone?: SummaryTone
}

/**
 * Synthèse compacte au-dessus d'une liste (Facturation) : une rangée d'indicateurs dans une seule
 * carte, puis la portée temporelle des montants et une mention secondaire facultative.
 */
export function SummaryStrip({
  label,
  metrics,
  scope,
  note,
}: {
  label: string
  metrics: readonly SummaryMetric[]
  scope?: ReactNode
  note?: ReactNode
}) {
  if (metrics.length === 0) return null
  return (
    <section className="ds-summary-strip" aria-label={label}>
      <dl className="ds-summary-strip__metrics">
        {metrics.map((metric) => (
          <div key={metric.key} className="ds-summary-strip__metric">
            <dt>{metric.label}</dt>
            <dd className={`ds-summary-strip__value ds-summary-strip__value--${metric.tone ?? 'neutral'}`}>
              {metric.value ?? '—'}
            </dd>
            <dd className="ds-summary-strip__detail">{metric.detail}</dd>
          </div>
        ))}
      </dl>
      {scope || note ? (
        <div className="ds-summary-strip__footer">
          {scope ? <span>{scope}</span> : null}
          {note ? <span>{note}</span> : null}
        </div>
      ) : null}
    </section>
  )
}
